module.exports = __webpack_public_path__ + "img/bgHero.a01e588a.jpg";